/** @jsx isolateComponent */

import PropTypes from 'prop-types';

import { Colors } from '@zapier/theme';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

import Config from 'app/common/Config';
import Icon from 'app/common/components/Icon';
import PageSection from 'app/common/components/PageSection.js';
import TextInput from 'app/common/components/TextInput.js';
import purify from 'app/common/components/purify';

const Styles = labelStyles(__filename, {
  root: {
    borderBottom: `1px solid ${Colors.adamantium}`,
    borderTop: `1px solid ${Colors.adamantium}`,
    display: 'block',
    padding: 0,
    width: '100%',
    'input:focus': {
      background: Colors.white,
    },
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  searchInputWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '1em 0',
    width: '100%',
  },
  searchInput: {
    border: 'none',
    fontSize: '1.3em',
    margin: '0 auto',
    ':focus': {
      backgroundColor: Colors.white,
      border: 'none',
    },
  },
  iconSearch: {
    color: Colors.steel,
    width: '22px',
    height: '22px',
  },
});

const SearchBar = ({ onSearchServices }) => {
  const placeholder = `Search ${Config.numberOfApps}+ Apps`;
  return (
    <div css={Styles.root}>
      <PageSection css={Styles.searchContainer} kind="padded-horz">
        <div css={Styles.searchInputWrapper}>
          <Icon css={Styles.iconSearch} type="search" />
          <TextInput
            css={Styles.searchInput}
            onChange={onSearchServices}
            placeholder={placeholder}
            type="text"
          />
        </div>
      </PageSection>
    </div>
  );
};

SearchBar.propTypes = {
  onSearchServices: PropTypes.func.isRequired,
};

export default purify(SearchBar);
